import { reset } from "redux-form";
import Client from "../Client";

import {
  JOB_UPDATED,
  JOB_SELECTED,
  ADD_JOB_ITEM,
  REMOVE_JOB_ITEM,
  UPDATE_JOB_ORDER,
  JOB_ATTACHMENT_FETCHED,
  UPDATE_JOB_SEQUENCE,
  ITEM_TYPES
} from "../types";

export const getJobAttachment = (runsheetId, jobId) => dispatch =>
  Client.getJobAttachment(runsheetId, jobId).then(response => {
    dispatch({
      type: JOB_ATTACHMENT_FETCHED,
      payload: response.jobAttachments
    });
  });

export const updateJob = (externalId, attributes) => ({
  type: JOB_UPDATED,
  payload: { externalId, attributes }
});

export const addJobItem = (jobExternalId, attributes) => dispatch => {
  const { quantity, code, description, type } = attributes;
  const item = {
    quantity: parseInt(quantity, 10),
    code,
    description,
    type
  };
  const jobItem = { item };

  dispatch({
    type: ADD_JOB_ITEM,
    payload: { jobExternalId, jobItem }
  });
};

export const resetJobItemForm = () => dispatch => {
  dispatch(reset("jobItem"));
};

export const selectJob = id => ({
  type: JOB_SELECTED,
  payload: id
});

export const updateJobOrder = (runsheetId, jobIds) => dispatch => {
  dispatch({
    type: UPDATE_JOB_ORDER,
    payload: {
      runsheetId,
      jobIds
    }
  });
};

export const updateJobSequence = (jobExternalId, sequence) => dispatch => {
  dispatch({
    type: UPDATE_JOB_SEQUENCE,
    payload: { jobExternalId, sequence }
  });
};

export const removeJobItem = (jobExternalId, index) => dispatch => {
  dispatch({
    type: REMOVE_JOB_ITEM,
    payload: { jobExternalId, index }
  });
};

export const updateJobLocationType = (
  jobExternalId,
  locationType
) => dispatch => {
  dispatch({
    type: "UPDATE_JOB_LOCATION_TYPE",
    payload: { jobExternalId, locationType }
  });
};

export const updateJobLocation = (jobExternalId, locationId) => dispatch => {
  dispatch({
    type: "UPDATE_JOB_LOCATION",
    payload: { jobExternalId, locationId }
  });
};

const getErrors = job => {
  let errors = [];
  const { customerName, type, stop } = job;
  const { location } = stop;

  if (customerName.trim() === "") {
    errors.push("customerName");
  } else {
    errors = errors.filter(error => error !== "customerName");
  }

  if (location.type.code === "") {
    errors.push("location");
  } else {
    errors = errors.filter(error => error !== "location");
  }

  if (type === "") {
    errors.push("type");
  } else {
    errors = errors.filter(error => error !== "type");
  }

  return errors;
};

export const validJob = job => {
  const errors = getErrors(job);
  return errors.length === 0;
};

export const getJobErrors = job => getErrors(job);

export const getItemTypes = () => dispatch =>
  Client.getItemTypes().then(response => {
    dispatch({
      type: ITEM_TYPES,
      payload: response
    });
  });



// WEBPACK FOOTER //
// ./src/actions/jobs.js